import { IconType } from "@onemind-services-llc/react-icons-ng";
import { StaticImageData } from "next/image";
import baremetalImg from "public/iaas/baremetal.png";
import blockStorageImg from "public/iaas/block_storage1.png";
import dedicatedServerImg from "public/iaas/dedicated_server.png";
import disasterRecoveryImg from "public/iaas/disaster_recovery.png";
import gpuHostingImg from "public/iaas/gpu_hosting.png";
import kubernetesImg from "public/iaas/kubernetes.png";
import vdiImg from "public/iaas/virtual_device_infrastructure.png";
import ManagedUnmanagedComanaged from "public/privateCloud/icons/managed-unmanaged-comanaged.png";
import OpenStackCloud from "public/privateCloud/icons/openstack-cloud.png";
import VMwareCloud from "public/privateCloud/icons/vmware-cloud.png";
import ZadaraCloud from "public/privateCloud/icons/zadara-cloud.png";
import CertificationLabs from "public/pocCloud/icons/certification-labs.png";
import EmulateSimulateReal from "public/pocCloud/icons/emulate-simulate-real.png";
import NetworkAutomation from "public/pocCloud/icons/network-automation.png";
import NetworkDigitalTwins from "public/pocCloud/icons/network-digital-twins.png";
import PerformanceLabs from "public/pocCloud/icons/performance-labs.png";
import PhysicalLabs from "public/pocCloud/icons/physical-labs.png";
import NetworkNMS from "public/network-services/icons/network-nms.png";
import NocSocHelpdesk from "public/network-services/icons/noc-soc-helpdesk.png";
import SdnSdWan from "public/network-services/icons/sdn-sd-wan.png";
import WiredWirelessNetwork from "public/network-services/icons/wired-wireless-network.png";
import HostedCMS from "public/application-services/icons/hosted-cms.png";
import HostedElastic from "public/application-services/icons/hosted-elastic.png";
import HostedGrafana from "public/application-services/icons/hosted-grafana.png";
import HostedNetbox from "public/application-services/icons/hosted-netbox.png";
import HostedOpenText from "public/application-services/icons/hosted-open-text.png";
import Inuvika from "public/application-services/icons/inuvika.png";
import Rancher from "public/application-services/icons/rancher.png";

import {
  APPLICATION_SERVICES_ROUTES,
  CLOUD_SERVICES_ROUTES,
  IAAS_ROUTES,
  MAIN_ROUTES,
  NETWORK_SERVICES_ROUTES,
} from "@/constants/routes";

export type NavItem = {
  icon?: IconType;
  image?: StaticImageData;
  label: string;
  subLabel?: string;
  href?: string;
  children?: NavItem[];
};

export const PRIVATE_CLOUD_CONSTANTS = [
  {
    image: OpenStackCloud,
    label: "Managed Open Stack(MOST)",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.OPEN_STACK_CLOUD}`,
  },
  {
    image: ZadaraCloud,
    label: "Zadara Cloud",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.ZADARA_CLOUD}`,
  },
  {
    image: VMwareCloud,
    label: "VMware Cloud",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.VMWARE_CLOUD}`,
  },
  {
    image: disasterRecoveryImg,
    label: "OEM Converged Architecture",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.OEM_CONVERGED_ARCHITECTURE}`,
  },
  {
    image: kubernetesImg,
    label: "Private K8 clusters",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PRIVATE_K8_CLUSTERS}`,
  },
  {
    image: gpuHostingImg,
    label: "Virtuozzo PAAS",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.VIRTUOZZO_PAAS}`,
  },
  {
    image: dedicatedServerImg,
    label: "Encrypted Storage Clusters",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.ENCRYPTED_STORAGE_CLUSTERS}`,
  },
  {
    image: ManagedUnmanagedComanaged,
    label: "Managed, Unmanaged, Co-managed",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.MANAGED_UNMANAGED_CO_MANAGED}`,
  },
];

export const POC_CLOUD_CONSTANTS = [
  {
    image: vdiImg,
    label: "Lab-as-a-service",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.LAB_AS_A_SERVICE}`,
  },
  {
    image: disasterRecoveryImg,
    label: "POC-as a service",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.POC_AS_A_SERVICE}`,
  },
  {
    image: NetworkDigitalTwins,
    label: "Network Digital Twins",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.NETWORK_DIGITAL_TWINS}`,
  },
  {
    image: CertificationLabs,
    label: "Certification Labs",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.CERTIFICATION_LABS}`,
  },
  {
    image: PhysicalLabs,
    label: "Physical Labs (SI | VAR|COE)",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PHYSICAL_LABS}`,
  },
  {
    image: NetworkAutomation,
    label: "Network Automation",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.NETWORK_AUTOMATION}`,
  },
  {
    image: PerformanceLabs,
    label: "Performance Labs | OEM Test Labs",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PERFORMANCE_LABS}`,
  },
  {
    image: EmulateSimulateReal,
    label: "Emulate | Simulate | Real",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.EMULATE_SIMULATE_REAL}`,
  },
];

export const IAAS_CONSTANTS = [
  {
    image: baremetalImg,
    label: "Bare-Metal Server",
    href: `${MAIN_ROUTES.IAAS}${IAAS_ROUTES.BAREMETAL}`,
  },
  {
    image: dedicatedServerImg,
    label: "Dedicated Servers",
    href: `${MAIN_ROUTES.IAAS}${IAAS_ROUTES.DEDICATED_SERVER}`,
  },
  {
    image: gpuHostingImg,
    label: "GPU Hosting",
    href: `${MAIN_ROUTES.IAAS}${IAAS_ROUTES.GPU_HOSTING}`,
  },
  {
    image: vdiImg,
    label: "Virtual Desktop Infrastructure (VDI) ",
    href: `${MAIN_ROUTES.IAAS}${IAAS_ROUTES.VDI}`,
  },
  {
    image: blockStorageImg,
    label: "Block Storage | S3 Storage ",
    href: `${MAIN_ROUTES.IAAS}${IAAS_ROUTES.BLOCK_AND_S3_STORAGE}`,
  },
  {
    image: disasterRecoveryImg,
    label: "Disaster Recovery ",
    href: `${MAIN_ROUTES.IAAS}${IAAS_ROUTES.DISASTER_RECOVERY}`,
  },
];

export const NETWORK_SERVICES_CONSTANTS = [
  {
    image: OpenStackCloud,
    label: "VMware Migration",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.VMWARE_MIGRATION}`,
  },
  {
    image: baremetalImg,
    label: "Migrate to Zadara",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.MIGRATE_TO_ZADARA}`,
  },
  {
    image: SdnSdWan,
    label: "SDN | SD-WAN | Wired | Wireless",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.SDN_SD_WAN_WIRED_WIRELESS}`,
  },
  {
    image: WiredWirelessNetwork,
    label: "Wired and Wireless Networks",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.WIRED_AND_WIRELESS_NETWORKS}`,
  },
  {
    image: vdiImg,
    label: "Design and Deployment",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.DESIGN_AND_DEPLOYMENT}`,
  },
  {
    image: NetworkNMS,
    label: "Network Observability and NMS",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.NETWORK_OBSERVABILITY_AND_NMS}`,
  },
  {
    image: disasterRecoveryImg,
    label: "Colocation",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.COLOCATION}`,
  },
  {
    image: NocSocHelpdesk,
    label: "NOC | SOC | Helpdesk",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.NOC_SOC_HELPDESK}`,
  },
];

export const APPLICATION_SERVICES_CONSTANTS = [
  {
    image: HostedOpenText,
    label: "Hosted Open-Text NOM",
    href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPLICATION_SERVICES_ROUTES.HOSTED_NOM}`,
  },
  {
    image: HostedElastic,
    label: "Hosted Elastic",
    href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPLICATION_SERVICES_ROUTES.HOSTED_ELASTIC}`,
  },
  {
    image: HostedGrafana,
    label: "Hosted Grafana",
    href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPLICATION_SERVICES_ROUTES.HOSTED_GRAFANA}`,
  },
  {
    image: HostedCMS,
    label: "Hosted CMS ",
    href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPLICATION_SERVICES_ROUTES.HOSTED_CMS}`,
  },
  {
    image: HostedNetbox,
    label: "Hosted Netbox",
    href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPLICATION_SERVICES_ROUTES.HOSTED_NETBOX}`,
  },
  {
    image: Rancher,
    label: "Hosted Rancher",
    href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPLICATION_SERVICES_ROUTES.HOSTED_RANCHER}`,
  },
  {
    image: Inuvika,
    label: "Inuvika VDI Platform",
    href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPLICATION_SERVICES_ROUTES.INUVIKA_VDI}`,
  },
];

export const NAV_ITEMS: Array<NavItem> = [
  {
    label: "Cloud Services",
    href: MAIN_ROUTES.CLOUD_SERVICES,
    children: [
      { label: "Private Cloud", children: PRIVATE_CLOUD_CONSTANTS },
      { label: "POC Cloud", children: POC_CLOUD_CONSTANTS },
    ],
  },
  { label: "IaaS", href: MAIN_ROUTES.IAAS, children: IAAS_CONSTANTS },
  {
    label: "Network Services",
    href: MAIN_ROUTES.NETWORK_SERVICES,
    children: NETWORK_SERVICES_CONSTANTS,
  },
  {
    label: "Application Services",
    href: MAIN_ROUTES.APPLICATION_SERVICES,
    children: APPLICATION_SERVICES_CONSTANTS,
  },
  {
    label: "Company",
    href: MAIN_ROUTES.ABOUT_US,
    children: [
      { label: "About Us", href: MAIN_ROUTES.ABOUT_US },
      { label: "Data Centers", href: MAIN_ROUTES.DATA_CENTER },
    ],
  },
];

export const NAV_BUTTON = {
  label: "Book A Consultation",
  href: MAIN_ROUTES.BOOK_A_CONSULTATION,
};
